















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";

import { IProperty } from "../../models/interfaces/property/property.model.interface";
import { Property } from "../../models/property/property.model";

import PropertyDetails from "@/components/property/PropertyDetails.vue";
import PropertyAdvertisingControls from "@/components/property/PropertyAdvertisingControls.vue";
import ZonesTable from "@/components/property/ZonesTable.vue";
import PropertyProductCategories from "@/components/property/PropertyProductCategories.vue";
import PropertyBlockBrands from "@/components/property/PropertyBlockBrands.vue";

const PropertyManagementModule = namespace("propertyManagementModule");

@Component({
  components: {
    PropertyDetails,
    PropertyProductCategories,
    PropertyAdvertisingControls,
    PropertyBlockBrands,
    ZonesTable
  }
})
export default class PropertyManager extends Vue {
  @PropertyManagementModule.Getter public property;
  @PropertyManagementModule.Action public retrieveProperty;

  get getPropertyModel(): IProperty {
    return this.property;
  }

  @Prop() public propertyId: number;

  @Provide() public propertyModel: IProperty = new Property();

  private loading: boolean = false;

  @Watch("getPropertyModel", { deep: true })
  public onPropertyUpdate() {
    this.propertyModel = this.property;
  }

  public created() {
    this.getProperty(this.propertyId);
  }

  private getProperty(id: number) {
    this.loading = true;
    this.retrieveProperty(id).then((result) => {
      if (this.property) {
        this.propertyModel = this.property;
        this.loading = false;
      }
    });
  }
}
